import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const areas = [
  'Jensen Beach', 'Port St. Lucie', 'Stuart', 'Palm City', 'Port Salerno',
  'Hobe Sound', 'Jupiter', 'Juno Beach', 'Palm Beach Gardens', 'Riviera Beach',
  'West Palm Beach', 'Royal Palm Beach', 'Lake Worth', 'Boynton Beach',
  'Delray Beach', 'Boca Raton', 'Melbourne', 'Vero Beach', 'Palm Springs',
];

export function ServiceAreas() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-28 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" ref={ref}>
        {/* Header */}
        <div className={`anim-hidden ${isVisible ? 'animate-fade-in-up' : ''} grid grid-cols-1 lg:grid-cols-2 gap-10 items-start mb-16`}>
          <div>
            <span className="luxury-divider" />
            <span className="text-xs font-bold uppercase tracking-[5px] text-[#C9A96E] mb-4 block">
              Service Areas
            </span>
            <h2
              className="text-4xl sm:text-5xl font-bold text-[#0A0A0A] leading-tight tracking-tight"
              style={{ fontFamily: 'Sora, sans-serif' }}
            >
              Window Tinting Across
              <br />
              <strong className="text-[#FF6B35]">Martin &amp; Palm Beach County</strong>
            </h2>
          </div>
          <div className="flex flex-col justify-end gap-4">
            <p className="text-gray-500 text-sm leading-relaxed">
              Based in Palm City, FL — we proudly serve vehicle owners, homeowners, and businesses throughout South Florida. Mobile service available for larger projects.
            </p>
            <div className="flex items-center gap-3">
              <i className="ri-map-pin-2-fill text-[#FF6B35] text-xl" />
              <span className="text-[#0A0A0A] text-sm font-semibold">
                1257 SW Martin Hwy, Palm City, FL 34990
              </span>
            </div>
          </div>
        </div>

        {/* City tags */}
        <div className={`anim-hidden ${isVisible ? 'animate-fade-in-up delay-200' : ''} flex flex-wrap gap-3 mb-14`}>
          {areas.map((area) => (
            <span
              key={area}
              className="inline-flex items-center gap-1.5 bg-[#F7F5F2] border border-gray-200 hover:bg-[#FF6B35] hover:border-[#FF6B35] hover:text-white text-[#0A0A0A] text-sm font-medium px-4 py-2 rounded-full transition-all duration-200 cursor-default"
            >
              <i className="ri-map-pin-line text-xs text-[#FF6B35] group-hover:text-white" />
              {area}
            </span>
          ))}
        </div>

        {/* Map */}
        <div
          className={`anim-hidden ${isVisible ? 'animate-scale-in delay-300' : ''} rounded-3xl overflow-hidden border border-gray-100 relative`}
        >
          <div className="absolute top-5 left-5 z-10">
            <div className="bg-[#0A0A0A] text-white px-4 py-2.5 rounded-xl text-sm font-semibold flex items-center gap-2">
              <i className="ri-store-2-line text-[#FF6B35]" />
              Mr. Tint of America — Palm City, FL
            </div>
          </div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3549.8319334750254!2d-80.27476691528874!3d27.16157768877374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88dedcd667ab406d%3A0x4f828f7c163a70c3!2s1257%20SW%20Martin%20Hwy%2C%20Palm%20City%2C%20FL%2034990!5e0!3m2!1sen!2sus!4v1731721794275!5m2!1sen!2sus"
            width="100%"
            height="460"
            style={{ border: 0, filter: 'grayscale(20%) contrast(1.05)' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Mr. Tint of America Location - Window Tinting Palm City FL"
          />
        </div>

        {/* Hours strip */}
        <div
          className={`anim-hidden ${isVisible ? 'animate-fade-in-up delay-400' : ''} mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4`}
        >
          {[
            { icon: 'ri-time-line', title: 'Mon – Fri', hours: '8:00 AM – 6:00 PM' },
            { icon: 'ri-calendar-line', title: 'Saturday', hours: '9:00 AM – 4:00 PM' },
            { icon: 'ri-phone-line', title: 'Call for Appointment', hours: '(561) 275-9473' },
          ].map((item) => (
            <div
              key={item.title}
              className="bg-[#F7F5F2] rounded-2xl px-6 py-5 flex items-center gap-4"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl flex-shrink-0">
                <i className={`${item.icon} text-[#FF6B35] text-lg`} />
              </div>
              <div>
                <div className="text-xs text-gray-400 uppercase tracking-widest mb-0.5">{item.title}</div>
                <div className="text-sm font-bold text-[#0A0A0A]" style={{ fontFamily: 'Sora, sans-serif' }}>
                  {item.hours}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
